import React from 'react';
import { Wrapper, Heading, Content, ImageWrapper, TopIcon, Tnc } from './styles';

const Popup1 = () => (
  <Wrapper>
    <TopIcon>
      <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/icon2.png`} alt="" width="100" />
    </TopIcon>
    <Heading>FLAC 無損格式</Heading>
    <br />
    <hr />
    <Content>
    MOOV是香港首個及唯一音樂串流平台在流動應用程式內提供 24 bit FLAC 無損音樂<sup>#</sup>。2015年起，MOOV以 16 bit FLAC格式為用戶提供無損音樂，音質媲美實體CD的音色，為HiFi入門級別。2020年，破天荒提供 24 bit FLAC 串流及下載服務，再次提升音質表現。
    <br />
    <br />
實體CD是由WAV檔編製，但WAV檔案巨大，如在手機進行串流及下載，均會佔據很大空間。而MOOV採用的FLAC格式能夠百份百保存原音檔案的所有數據，不會破壞原有檔案，保證聲音數據的完整性，達至真正的無損音樂。
      <br />
      <br />
      <div>AAC格式 (128 kbps) - 16 bit / 44.1 kHz</div>
      <br />
      <ImageWrapper>
        <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/soundwave_1.png`} alt="" width="100%" />
      </ImageWrapper>
      <div>聲音數據經過AAC格式處理後，檔案體積會變得輕盈，但聲音數據無法完整展現。</div>
      <br />
      <br />
      <div>FLAC格式 - 16 bit / 44.1 kHz</div>
      <br />
      <ImageWrapper>
        <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/soundwave_2.png`} alt="" width="100%" />
      </ImageWrapper>
      <div>FLAC無損格式有別於AAC格式，聲音數據能夠完整保存，但礙於動態範圍仍然被 16 bit 所局限，導致最細緻的音量資訊無法呈現。</div>
      <br />
      <br />
      <div>FLAC格式 - 24 bit / 192 kHz</div>
      <br />
      <ImageWrapper>
        <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/pic3_r2.png`} alt="" width="100%" />
      </ImageWrapper>
      <div>聲音數據在 24 bit FLAC的格式下，再細微的音頻資訊亦能夠忠實地呈現。</div>
      <br />
      <Tnc>
        <em>以上圖表僅作說明之用。實際聲頻表現會按位元度 (Bit depth) 及 取樣頻率 (Sampling rate) 不同而有所影響。</em>
        <br />
        #根據MOOV針對在香港營運之8大音樂串流平台之內部調查。截至2020年3月16日，MOOV擁有香港最大 24 bit FLAC 無損串流音樂庫提供 24 bit FLAC 無損音樂庫及音源資訊包括位元度、取樣頻率、音頻格式、版本及位元率之音樂串流平台。
      </Tnc>
    </Content>
  </Wrapper>
)

export default Popup1;